import { MCP_TECHNOLOGY_ID } from '@/core/const/mcpGateway.const'
import { Runtime } from '@/core/enums/runtime.enum'
import { PACKAGE_MANAGER_MAP } from '@/core/utils/installation'

export function resolveSnippetTechnology(
  selectedTechnology: string | undefined,
  runtimeName: string | undefined
): string | undefined {
  if (!selectedTechnology) return undefined

  if (selectedTechnology !== MCP_TECHNOLOGY_ID) {
    return selectedTechnology
  }

  if (!runtimeName || !(runtimeName in PACKAGE_MANAGER_MAP)) {
    return undefined
  }

  return PACKAGE_MANAGER_MAP[runtimeName as Runtime]
}
